import PropTypes from 'prop-types';
import React from 'react';
import Classes from 'classnames';
import RenderComponentProto from '../../render-component-proto';
import InputInlineEditable from '../../../../gd-components/input-inline-editable/input-inline-editable'

class PercentageComponentProto extends RenderComponentProto {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            invalidValue: false,
            isEditing: false,
        };

        this.commited = true;

        this._bind('onFocus', 'onBlur', 'onChange', 'onImmediateChange', 'setActive');
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value) {
            this.updateValue(newProps.value);
        }
    }

    updateValue(val) {
        this.setState({
            value: val,
            invalidValue: !(_.isNil(val) || !isNaN(val) || val.length === 0)
        });
    }

    setActive() {
        this.setState({isEditing: true}, () => {
            if (this.refs.input) this.refs.input.focus();
        });
    }

    setInactive() {
        this.setState({isEditing: false});
    }

    onFocus(e) {
        if (this.props.onFocus) this.props.onFocus(e)
    }

    onBlur(e) {
        this.setInactive();
        if (this.props.onBlur) this.props.onBlur(e);
    }

    onChange(newValue) {
        this.commited = true;

        if (!isNaN(newValue) || newValue.length === 0) {
            if (this.props.onChange) this.props.onChange(parseFloat(newValue));
        }
    }

    onImmediateChange(newValue) {
        this.commited = false;
        this.updateValue(newValue);
    }

    getNormalizedValue() {
        const { value, invalidValue } = this.state;
        if (invalidValue) return null;

        const cf = gd.session.customFields.get(this.props.id);
        const decimalPlaces = cf.params ? cf.params.decimalPlaces : 0;

        const normalized = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);

        return isNaN(normalized) ? null : normalized;
    }

    renderActive() {
        let classes;

        switch (this.props.renderMode) {
            case 'list':
            case 'view':
            case 'form-new':
                classes = Classes('gd-field-percentage', 'active', this.props.renderMode, {
                    'invalid-value': this.state.invalidValue,
                });
                break;

            case 'edit':
                classes = Classes('gd-field-percentage', 'edit', {
                    'invalid-value': this.state.invalidValue,
                });
                break;
        }

        return (
            <div className={classes}>
                <InputInlineEditable ref="input"
                                     className=""
                                     placeholder=""
                                     value={this.getNormalizedValue()}
                                     disabled={this.props.canEdit === false}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     onChange={this.onChange}
                                     onImmediateChange={this.onImmediateChange}
                                     commitDelay={2000} />
                <div className="symbol">%</div>
            </div>
        );
    }

    renderInactive() {
        const normalizedValue = this.getNormalizedValue()

        let classes
        switch (this.props.renderMode) {

            case 'list':
            case 'view':
            case 'form-new':
                classes = Classes('gd-field-percentage', 'inactive', this.props.renderMode, {
                    'invalid-value': this.state.invalidValue,
                    'disabled': this.props.canEdit === false,
                    'is-empty': normalizedValue === null
                });
                break;

            case 'edit':
                classes = Classes('gd-field-percentage', 'edit', {
                    'invalid-value': this.state.invalidValue,
                    'disabled': this.props.canEdit === false,
                    'is-empty': normalizedValue === null
                });
                break;
        }

        let content = false;
        if (normalizedValue !== null) {
            content = [
                <span key={0} className="value">{normalizedValue}</span>,
                <span key={1} className="symbol">%</span>
            ];
        } else {
            content = [
                <span key={0} className="value"></span>
            ];
        }

        return (
            <div className={classes} onClick={this.props.canEdit ? this.setActive : null}>
                {content}
            </div>
        )
    }

    render() {

        if (this.props.renderMode=='form-new') return this.renderActive();

        return (this.state.isEditing || this.props.renderMode=='edit') ? this.renderActive() : this.renderInactive();
    }
}


PercentageComponentProto.propTypes = {
    id: PropTypes.string.isRequired,
    renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
    value: PropTypes.any,
    canEdit: PropTypes.bool,
    onChange: PropTypes.func,
};

PercentageComponentProto.defaultProps = {
    canEdit: true,
};

module.exports = PercentageComponentProto;